import React from "react";

function Receipt({ width = 20, height = 20, fill = "#F8F6F6" }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5ZM19 19.09H8V17.09H19V19.09ZM19 15.09H8V13.09H19V15.09ZM19 11.09H8V9.09H19V11.09Z"
                fill={fill}
            />
        </svg>
    );
}

export default Receipt;
